module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/public benefit-2f048ef07c497fcacda47fe732775a70.png";